// extracted by mini-css-extract-plugin
export default {"container":"Image_container__Skr80"};